var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"price-renderer"},[_c('span',{staticClass:"price-renderer__default-price",class:{
      'price-renderer__default-price--strikethrough': _setup.getHasValidCompareAtPrice,
      'price-renderer__default-price--strikethrough--inverted':
        _setup.getHasValidCompareAtPrice && _vm.inverted
    }},[_vm._v(" "+_vm._s(_setup.getDefaultPrice)+" ")]),(_setup.getHasValidCompareAtPrice)?_c('span',{class:_vm.inverted ? 'text--clr-purple' : 'text--clr-purple_dark'},[_vm._v(" "+_vm._s(_setup.getAdjustedPrice)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }